import { useEffect } from 'react';
import {
  TokenRequest,
  BaseTokenRequestHandler,
  GRANT_TYPE_AUTHORIZATION_CODE,
  AuthorizationServiceConfiguration,
  RedirectRequestHandler,
  AuthorizationNotifier,
  FetchRequestor,
  LocalStorageBackend,
  DefaultCrypto,
} from '@openid/appauth';
import { useNavigate } from 'react-router-dom';
// eslint-disable-next-line
import jwt_decode from 'jwt-decode';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import oidcConfig from '../../oidcConfig';
import NoHashQueryStringUtils from '../../noHashQueryStringUtils';
import useAuth from '../../hooks/useAuth';
import { setUserID } from '../../store/GoogleAnalytics/actions';

const AuthenticationCallback = ({ onSetUserID }) => {
  const navigate = useNavigate();
  const auth = useAuth();

  // Made token request once received the authorization response or error
  useEffect(() => {
    const tokenHandler = new BaseTokenRequestHandler(new FetchRequestor());
    const authorizationHandler = new RedirectRequestHandler(
      new LocalStorageBackend(),
      new NoHashQueryStringUtils(),
      window.location,
      new DefaultCrypto(),
    );
    const notifier = new AuthorizationNotifier();
    authorizationHandler.setAuthorizationNotifier(notifier);
    notifier.setAuthorizationListener((request, authorizationResponse, authorizationError) => {
      if (authorizationResponse) {
        let extras = null;
        if (request && request.internal) {
          extras = {};
          extras.code_verifier = request.internal.code_verifier;
          extras.scope = oidcConfig.scope;
        }

        const tokenRequest = new TokenRequest({
          client_id: oidcConfig.clientId,
          redirect_uri: oidcConfig.redirectURL,
          grant_type: GRANT_TYPE_AUTHORIZATION_CODE,
          code: authorizationResponse.code,
          refresh_token: undefined,
          extras,
        });

        AuthorizationServiceConfiguration.fetchFromIssuer(oidcConfig.OPServer, new FetchRequestor())
          .then((configuration) => {
            return tokenHandler.performTokenRequest(configuration, tokenRequest);
          })
          .then((tokenResponse) => {
            const decodedIdToken = jwt_decode(tokenResponse.idToken);
            console.log('decodedIdToken:', decodedIdToken);
            const userId = decodedIdToken.sub;
            onSetUserID(userId);
            auth.setTokenResponse(tokenResponse);
            navigate('/');
          })
          .catch((tokenError) => {
            console.error('Token response error:', tokenError);
          });
      } else {
        console.error('Authorization response error:', authorizationError);
      }
    });
    authorizationHandler.completeAuthorizationRequestIfPossible();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `auth` and `navigate` should not be passed into the dependencies array
  }, []);

  return <div>Loading...</div>;
};

AuthenticationCallback.propTypes = {
  onSetUserID: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onSetUserID: setUserID,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(AuthenticationCallback);
